export const ua = {
    head: {
        emtpl: {
            title: 'Розрахувати ціну автоцивілки та купити поліс онлайн',
            metaDescription: 'Розрахуйте автоцивілку ✔️ Доступна ціна на страховку авто ✔️ Оформлення за 7 хвилин ⭐ Купити автоцивілку легко з ARX!'
        },
        emtplSmartDrive: {
            title: 'eMTPL',
            metaDescription: 'eMTPL'
        },
        travel: {
            title: 'Туристичне страхування онлайн - купити страховку для виїзду за кордон',
            metaDescription: 'Туристичне страхування за доступною ціною ✔️ Оформити туристичну страховку онлайн для виїзду за кордон ✈️ Готовий поліс миттєво ⭐ Надійність та зручність!'
        },
        greenCard: {
            title: 'Зелена карта: ціна та оформлення - Калькулятор Грін Карт',
            metaDescription: 'Купити Зелену карту для виїзду за кордон онлайн з ARX ✔️ Легкий розрахунок ціни зеленої карти на авто ✔️ Оформлення за 7 хвилин та вигідні умови!'
        },
        check: {
            title: 'Перевірка чинності полісу',
            metaDescription: 'Подорожуй з найпрофесійнішою страховою компанією України'
        }
    },
    travel: {
        header: {
            name: 'Туристичне страхування',
            description: 'Подорожуй з найпрофесійнішою страховою компанією України'
        },
        forms: {
            preferCountry: "Оберіть країну, яка є головною метою Вашої подорожі",
            importantInfo: "Важлива інформація для тих, хто купує поліс з-за кордону",
            importantInfoDesc1: "Зміни для тих, хто тривалий час перебуває за кордоном:",
            importantInfoDesc2: "- Якщо ви маєте право знаходитись в певній країні понад 90 днів (наприклад, маєте посвідку на проживання аботимчасовий захист),",
            importantInfoDesc3: " поліс туристичного страхування в цій країні не буде діяти.",
            importantInfoDesc4: "- Якщо ви купуєте поліс, перебуваючи за кордоном і у вас немає попереднього поліса туристичного страхування в АРКС - потрібно оформити поліс за 5 днів до дати початку подорожі. Це гарантує, що поліс буде активний від першого дня поїздки. Ви сплачуєте тільки за дні, які плануєте провести у подорожі.",
            importantInfoDesc5: " Якщо поліс оформлено пізніше, активація відбудеться після 5 днів з дати купівлі.",
            startDate: "Дата виїзду",
            endDate: "Дата повернення",
            startDateDesc1: "Зміни для тих, хто тривалий час перебуває за кордоном:",
            startDateDesc2: "- Якщо ви маєте право знаходитись в певній країні понад 90 днів (наприклад, маєте посвідку на проживання або тимчасовий захист),",
            startDateDesc3: " поліс туристичного страхування в цій країні не буде діяти.",
            startDateDesc4: "- Якщо ви купуєте поліс, перебуваючи за кордоном і у вас немає попереднього поліса туристичного страхування в АРКС - потрібно оформити поліс за 5 днів до дати початку подорожі. Це гарантує, що поліс буде активний від першого дня поїздки. Ви сплачуєте тільки за дні, які плануєте провести у подорожі.",
            startDateDesc5: " Якщо поліс оформлено пізніше, активація відбудеться після 5 днів з дати купівлі.",
            endDateDesc1: "Для клієнтів, які оформлюють туристичне страхування на території України:",
            endDateDesc2: "Клієнти, які купують поліс, перебуваючи в Україні, користуються стандартним алгоритмом оформлення без додаткових умов."
        }
    },
    check: {
        header: {
            name: 'Перевірка чинності полісу',
            description: 'Подорожуй з найпрофесійнішою страховою компанією України'
        },
        footer: '© Страхова компанія "АRX" 2022'
    },
    edit: "Редагувати",
    category: "Категорія",
    categoryLong: "Категорія транспортного засобу",
    brand: "Марка",
    model: "Модель",
    brandLong: "Марка авто",
    modelLong: "Модель авто",
    calculate: "Розрахунок",
    price: "Ціна:",
    touristData: 'Дані туриста',
    address: 'Адреса проживання',
    coverage: "Покриття:",
    expiration: "Строк дії:",
    additional: "Додатково:",
    sendAnotherMail: "Відправити на іншу пошту",
    send: "Відправити",
    noAdditionalCoverage: "Без розширеного захисту",
    learnMoreAboutVtpl: "Дізнатися більше про умови Додаткової автоцивілки",
    learnMoreAboutCasco: "Дізнатися більше про КАСКО «Прямий захист»",
    chooseFromSelected: "Оберіть з вибраного:",
    getCode: "Отримати код",
    and: "та",
    internationalPassport: 'Номер закордоного паспорту',
    code: "Код",
    controlCode: "Контрольний код:",
    wrongCode: "Код невірний!",
    confirm: "Підтвердити",
    sendAgain: "відправити код ще раз",
    important: "Важливо!",
    yes: "Так",
    congrats: "Вітаємо!",
    toMainPage: "Залишити заявку",
    toMainPageUrl: "https://arx.com.ua/produkty/avtotsyvilka/avtotsyvilka-paperova",
    problem: "Майже готово!",
    areYouHere: "Ви ще тут?",
    details: "Детальніше",

    optimalAdvertise1: 'Основний пакет',
    optimalAdvertise2: 'Надання невідкладної медичної допомоги у зв\'язку зі захворюваннями, що пов\'язані з особливо небезпечними інфекціями (в тому числі COVID-19)',
    optimalAdvertise2Tooltip: 'Надання швидкої невідкладної допомоги, невідкладної амбулаторної та стаціонарної допомоги в медичних закладах (оплачується вартість послуг та медикаментів) у зв\'язку зі захворюваннями, що пов\'язані з особливо небезпечними інфекціями (в тому числі covid-19). Даний ризик покриває оплату діагностичних тестів тільки при наявності симптомів особливо небезпечних інфекцій та симптомів хвороб органів дихання (клас Х МКБ 10). НЕ ПОКРИВАЮТЬСЯ: профілактичні діагностичні тести (тести, які потрібно зробити при перетині кордону країни в\'їзду з метою отримання права на в\'їзд, тестування у разі необхідності визначення наявності інфекції при появі інформації, що був контакт з інфікованим при відсутності симптомів захворювання, тестування за бажанням Застрахованої особи без необхідності з медичної точки зору, тестування без направлення лікуючого лікаря та без погодження з Асистансом та інші профілактичні тести) витрати на самоізоляцію чи обсервацію, витрати на евакуацію в Україну, оплату квитків для повернення в Україну, компенсацію витрат за невикористані квитки.',
    optimalAdvertise3: 'Надзвичайне подовження перебування',
    optimalAdvertise3Tooltip: 'Відшкодовується вартість подовженого перебування (проживання в готелі) до 10 діб (до 500 EUR), якщо в цьому є необхідність підтверджена лікарем',
    optimalAdvertise4: 'Дострокове повернення',
    optimalAdvertise4Tooltip: 'Відшкодовується вартість дострокового повернення Застрахованої особи у випадку смерті близького родича (до 500 EUR)',
    optimalAdvertise5: 'Відшкодування при затримці вильоту авіарейсу',
    optimalAdvertise5Tooltip: 'За кожну годину затримки рейсу понад 4 години відшкодовується 10 EUR, але не більше 100 EUR',
    optimalAdvertise6: 'Відшкодування при затримці багажу',
    optimalAdvertise6Tooltip: 'За кожну повну годину затримки багажу  понад  4 години відшкодовується 10 EUR, але не більше 100 EUR',
    optimalAdvertise7: 'Невідкладна гінекологічна допомога до 30-го тижня вагітності',
    optimalAdvertise7Tooltip: 'Невідкладна гінекологічна допомога до 30-го тижня вагітності',
    optimalAdvertise8: 'Медичний консьерж',
    optimalAdvertise9: 'Друга медична думка',

    premiumAdvertise1: 'Програма “Оптимальна”',
    premiumAdvertise1Tooltip: '',
    premiumAdvertise2: 'Надзвичайний приїзд третьої особи',
    premiumAdvertise2Tooltip: 'Візит третьої особи, якщо тривалість перебування Застрахованої особи у стаціонарі перевищує 10 діб (відшкодовується вартість квитків в економічному класі, проживання в готелі до 3-х діб (до 500 EUR)',
    premiumAdvertise3: 'Організація послуг адвоката',
    premiumAdvertise3Tooltip: 'Відшкодовуються послуги адвоката, якщо Застрахованій особі пред’явлено судовий позов  (в межах 1000 EUR)',
    premiumAdvertise4: 'Виплата при втраті особистих документів',
    premiumAdvertise4Tooltip: 'Виплата при втраті особистих документів (окрім банківської картки) Застрахованої особи (50 EUR  за кожний втрачений документ, але не більше150 EUR)',
    premiumAdvertise5: 'Організація доставки застрахованої особи до місця призначення при поломці авто',
    premiumAdvertise5Tooltip: 'Організація доставки Застрахованої особи до місця призначення (тільки у країнах Європи) у випадку поломки автомобіля, аварії або неможливості керування Застрахованою особою - водієм автомобілем за медичними показаннями (оплата таксі при наявності документів, що підтверджують дані витрати  - в межах 100 EUR)',

    classicAdvertise1: 'Основний пакет',
    classicAdvertise2: 'Надання невідкладної медичної допомоги у зв\'язку зі захворюваннями, що пов\'язані з особливо небезпечними інфекціями (в тому числі COVID-19)',
    classicAdvertise2Tooltip: 'Надання швидкої невідкладної допомоги, невідкладної амбулаторної та стаціонарної допомоги в медичних закладах (оплачується вартість послуг та медикаментів) у зв\'язку зі захворюваннями, що пов\'язані з особливо небезпечними інфекціями (в тому числі covid-19). Даний ризик покриває оплату діагностичних тестів тільки при наявності симптомів особливо небезпечних інфекцій та симптомів хвороб органів дихання (клас Х МКБ 10). НЕ ПОКРИВАЮТЬСЯ: профілактичні діагностичні тести (тести, які потрібно зробити при перетині кордону країни в\'їзду з метою отримання права на в\'їзд, тестування у разі необхідності визначення наявності інфекції при появі інформації, що був контакт з інфікованим при відсутності симптомів захворювання, тестування за бажанням Застрахованої особи без необхідності з медичної точки зору, тестування без направлення лікуючого лікаря та без погодження з Асистансом та інші профілактичні тести) витрати на самоізоляцію чи обсервацію, витрати на евакуацію в Україну, оплату квитків для повернення в Україну, компенсацію витрат за невикористані квитки.',
    classicAdvertise3: 'Медична консультація онлайн',

    residentTrue: 'Я є резидентом України',
    residentFalse: 'Я не є резидентом України',

    optimalAdvertiseTitle: 'Оптимальна',
    premiumAdvertiseTitle: 'Преміальна',
    classicAdvertiseTitle: 'Класична',

    learnMore: 'Дізнатися більше про умови',

    whatIsInsuredSum: 'Що таке страхова сума?',
    insuredSum: 'Страхова сума',
    insuredSum2: ' — це максимальна грошова виплата, яку ви можете отримати відповідно до умов страхування.',
    chooseYourProgram: 'Оберіть свою програму:',

    allWorld: 'Весь світ',
    allWorldExceptCanada: 'Весь світ, окрім США та Канади',
    allWorldExceptUSACanadaIndonesiaThailandIndia: 'Весь світ, окрім США, Канади, Індонезії, Таїланду та Індії',
    allWorldExceptUSIndonesiaThailandUkraine: 'Весь світ, окрім США, Індонезії, Таїланду та України',
    europeCic: 'Європа, країни СНД, Туніс, Туреччина, Єгипет',

    calculateDetails: 'Дані для розрахунку поїздки',
    checkDetails: 'Дані для перевірки полісу',

    coveredZone: 'Зона покриття страхового поліса',

    touristCount: 'К-ть туристів',
    travelPurpose: 'Мета поїздки',
    covidAdv: 'Покриття COVID-19',
    franchiseAdv: 'Нульова франшиза',
    activeAdv: 'Активний відпочинок включено',
    ageRange: 'Віковий діапазон від 1 до 75 років',
    prohibitionCancelled: 'Знято заборону на оформлення поліса Travel з-за кордону',
    ourAdv: 'Наші переваги',
    importantInfo: 'Корисна інформація',
    policyTermsFile: 'Умови страхування для подорожуючих за кордон',
    toCalculate: 'Розрахувати',
    findContract: 'Знайти',
    yourDetails: 'Вкажіть ваші дані',
    timeFranchise: "Якщо ви купуєте поліс за межами України - за вашим полісом буде діяти часова франшиза 5 днів (період очікування) з моменту початку дії договору.\n" +
        "Часова франшиза не застосовується, якщо поліс куплено в Україні та застрахована особа перетинає кордон України при поїздці за кордон.",

    livingAddress: 'Адреса проживання',
    mobileNumber: 'Телефон',
    registrationDocument: 'Номер закордоного паспорту',

    payerIsPerson: 'Страхувальник їде у подорож',

    travelAgree1_1: 'Додатково повідомлений, що при несплаті страхового платежу, договір страхування не набирає чинності та страхове покриття відсутнє. Цим також підтверджую, що мною була отримана згода Застрахованих осіб на їх страхування та на обробку, використання і передачу Страховику їх персональних даних з метою укладення та виконання цього договору. Підтверджую, що надані мною дані є точними та достовірними.',
    travelAgree1_2: 'Надаю згоду на використання моїх персональних даних, відповідно до Закону України "Про захист персональних даних".',
    travelAgree2_1: 'Надаю згоду на використання в усіх без виключення договірних відносинах зі Страхувальником та при здійсненні переписки з ним, в тому числі ділової, при посвідченні документів від імені Страховика особистого підпис уповноваженої на такі дії особи або факсимільного відтворення за допомогою засобів електронного або іншого копіювання аналога її власноручного підпису, наведеного нижче:',
    travelAgree2_2: '4',

    program: 'Програма страхування:',
    touristCountFull: 'Кільксіть туристів:',

    documentNumber: 'Номер паспорта:',
    addressFull: 'Адреса:',

    insurerTourist: 'Страхувальник (Турист 1)',
    tourist: 'Турист',

    error: "Помилка!",
    warning: "Попередження",
    errorDefaultMessage: "Зв'яжіться, будь ласка, з контакт-центром",
    emptyFieldErrorMessage: "Обов'язкове поле",
    engineCapacityErrorMessage: "Допускаються значення в діапазоні від 0 до 40000",
    ownerBirthDateErrorMessage: "Внесена дата народження Власника не допустима. Виберіть дату з календарю.",
    issueDateErrorMessage: "Дата видачі Документу має бути більше Дати народження та менше Поточної дати",
    incorrectEmailErrorMessage: "Email не корректний",
    tarifficationErrorMessage: "Не вдалося розрахувати ціну. Спробуйте ще раз.",
    reglamentErrorMessage1: "Вибачте!",
    reglamentErrorMessage3: "Шановні клієнти!\n " +
        " Даний сервіс тимчасово недоступний у зв’язку з плановими роботами на сайті.\n" +
        " Якщо у вас є питання, ви можете звернутися до нас у телеграм, вайбер або на сторінці фейсбук.\n" +
        " Для придбання полісу автоцивілки ви можете залишити заявку",
    reglamentErrorMessage2: "З 23:30 до 00:00 на сайті виконуються регламентні роботи.",
    reglamentErrorMessage2_GreenCard: "З 23:30 до 00:00 на сайті виконуються регламентні роботи.",
    smartDriveVehicleTypeMismatchError: 'Автоцивілку СМАРТ можна придбати тільки для легкових автомобілів або електроавтомобілів',
    identificationCodeError: "Код невірний!",
    unkwonwnError: "Сталася помилка! Спробуйте будь-ласка пізніше, або зв'яжіться із службою підтримки.",
    crashFallbackTitle: "Щось пішло не так",
    crashFallbackDescription: "Спробуйте оновити сторінку. Якщо проблема повториться, поверніться пізніше.",

    tariffication: {
        checkData: {
            plateNumber: {
                title: "Перевірте дані, що підтягнулись за державним номером.",
                text: "Якщо дані невірні - скористайтесь, будь ласка, опцією ввести дані вручну."
            },
            phoneNumber: {
                title: "Перевірте дані, що підтягнулись за номером телефону.",
                text: "Якщо дані невірні - скористайтесь, будь ласка, опцією ввести дані вручну."
            }
        }
    },

    noOptionsText: "Введіть принаймні 3 символи для початку пошуку",
    whatIsVin: "Що таке VIN?",
    whatIsAgreementPlace: "Що таке Місце укладання договору?",
    agreementPlaceDescription: "Якщо ви перебуваєте не в Україні, оберіть пункт - За межами України.",
    whatIsFranchise: "Що таке франшиза?",
    verifyPhone: "Підтвердження замовлення",
    verifyDescription1: "На номер ",
    verifyDescription2: " буде відправлено СМС з кодом підтвердження. Введіть отриманий код в наступному вікні.",

    processingDialogTitle: "Потрібно зачекати!",
    processingDialogText: "Обробляємо дані по платежу та оформлюємо ваш договір, це може зайняти деякий час.",
    processingDialogText2: "Обробляємо інформацію",

    scenarioHeaderDescription: "від лідера страхового ринку України",
    scenarioHeaderName: "Автоцивілка",

    toolbarSearch: "Підтягнути дані за номером авто",
    toolbarSearchShort: "За номером авто",
    toolbarManual: "Внести дані вручну",
    toolbarCheck: "Перевірити",
    toolbarNewClient: "Купую вперше",
    toolbarARXClient: "Я - клієнт ARX",

    menuQuestions: "Поширені запитання",
    menuAbout: "Про компанію",

    contacts: "Гаряча лінія",

    acceptButton: "Прийняти",

    additionalCoverageVtpl: "Додаткова автоцивілка",
    additionalCoverageCascoMessage: "Якщо в ДТП немає Вашої вини, ARX відшкодує вам збиток напряму, як по КАСКО, та без вирахування зносу. З КАСКО «Прямий захист» Вам не доведеться звертатися до страхової компанії винуватця ДТП.",
    additionalCoverageCascoMessageSmartDrive: "Якщо в ДТП немає Вашої вини, ARX відшкодує Вам збиток напряму, як по КАСКО, та без вирахування зносу. З КАСКО «Прямий захист» Вам не доведеться звертатися до страхової компанії винуватця ДТП.",
    additionalCoverageVtplMessage: "Якщо збиток перевищить страхову суму за обов'язковою Автоцивілкою, різницю відшкодуємо за додатковим полісом.",

    vehicle: "Транспортний засіб",
    vehicleData: "Дані транспортного засобу",
    vehicleTypeChoose: "Оберіть тип транспортного засобу:",
    vehiclePlateNumberType: "Введіть номер автомобіля:",
    vehiclePlateNumberDescription: "У разі введення державного номера дані зареєстрованого транспортного засобу будуть автоматично заповнені.",

    vehicleGroupB: "Легковий автомобіль",
    vehicleGroupA: "Мотоцикл",
    vehicleGroupC: "Вантажний автомобіль",
    vehicleGroupB5: "Легковий електромобіль",
    vehicleGroupE: "Причіп",
    vehicleGroupD: "Автобус",

    vehicleShortGroupB: "Легковий",
    vehicleShortGroupB5: "Електромобіль",
    vehicleShortGroupC: "Вантажний",

    vehicleType: "Тип транспортного засобу",
    vehicleTypeA1: "Мотоцикли та моторолери до 300 см³ включно",
    vehicleTypeA2: "Мотоцикли та моторолери понад 300 см³",
    vehicleTypeB1: "Легковий автомобіль до 1600 см³",
    vehicleTypeB2: "Легковий автомобіль від 1601 до 2000 см³",
    vehicleTypeB3_1: "Легковий автомобіль від 2001 до 2500 см³",
    vehicleTypeB3_2: "Легковий автомобіль від 2501 до 3000 см³",
    vehicleTypeB4: "Легковий автомобіль від 3001 см³ та більше",
    vehicleTypeB5: "Легковий електромобіль (винятково з силовим електродвигуном, крім гібридних авто)",
    vehicleTypeC1: "Вантажні автомобілі вантажопідйомністю до 2 т включно",
    vehicleTypeC2: "Вантажні автомобілі вантажопідйомністю понад 2 т",
    vehicleTypeD1: "Автобуси з кількістю місць для сидіння до 20 чоловік включно",
    vehicleTypeD2: "Автобуси з кількістю місць для сидіння більше 20 чоловік",
    vehicleTypeE: "Причепи до вантажних автомобілів",
    vehicleTypeF: "Причепи до легкових автомобілів",

    vehicleBrand: "Марка транспортного засобу",
    vehicleConstructionYear: "Рік випуску",
    vehicleConstructionYearLong: "Рік випуску транспортного засобу",
    vehiclePlateNumber: "Номер авто",
    vehiclePlateNumber2: "Номерний знак:",
    vehicleEngineCapacity: "Об’єм двигуна / Потужність акумулятора",
    vehicleEngineCapacity2: "Об’єм двигуна / Потужність акумулятора:",
    vehicleNextToDate: "Дата наступного огляду",
    vehicleOtk: "Строки проходження ОТК",
    vehicleVin: "VIN",
    vehicleVin2: "VIN:",
    vehicleVinDescription: " - це серійний номер авто для індивідуального розпізнавання транспортного засобу.",
    engineType: 'Тип двигуна',
    engineTypeLbl: {
        diesel: "Дизель",
        gasoline: "Бензин",
        electric: "Електричний",
        hybrid: "Гібрид",
        lpg: "Газ",
    },
    engineCapacity: 'Об’єм двигуна (см3)',
    batteryCapacity: 'Потужність електродвигуна (кВт)',
    totalWeight: 'Повна маса (кг)',
    ownWeight: 'Маса без навантаження (кг)',
    numberSeating: 'Кількість місць з водієм',

    vehicleOwnerPartyType: "Власник транспортного засобу",
    vehicleOwnerName: "ПІБ власника",
    vehicleOwnerAddress: "Адреса власника",
    vehicleOwnerBirthYear: "Рік народження власника транспортного засобу",
    vehicleOwnerBirthDate: "Дата народження власника",
    vehicleOwnerTaxiUsage: "Використовується як таксі",
    vehicleOwnerRequiredTO: "Підлягає обов'язковому технічному огляду",
    vehicleOwnerRegisterCity: "Місце реєстрації власника транспортного засобу",
    vehicleEngineCapacityDetail: 'Об’єм двигуна ТЗ (см3)',
    vehicleBatteryCapacity: 'Потужність електродвигуна ТЗ (кВт)',
    vehicleTotalWeight: 'Повна маса ТЗ (кг)',
    vehicleOwnWeight: 'Маса без навантаження ТЗ (кг)',
    vehicleNumberSeating: 'Кількість сидячих місць ТЗ із місцем водія',
    vehicleMinAgeDriver: 'Мінімальний вік водія (повних років)',
    vehicleMaxAgeDriver: 'Максимальний вік водія (повних років)',
    vehicleMinAgeDriverErrorLower: 'Мінімальний вік подія, не може бути менше 16 років.',
    vehicleMinAgeDriverErrorUpper: 'Максимальний вік водія, не може бути більше 99 років.',  

    vehicleNotFound: "На жаль, ми не знайшли дані за номером авто",
    vehicleNotFound1: "Перевірте коректність введення номеру авто або введіть ",
    vehicleNotFound2: "дані вручну",
    vehicleNotFoundChangeNumber: "Змінити номер",

    infoMessages: "Повідомлення",

    documentTypePassport: "Паспорт",
    documentTypeDriverLicense: "Посвідчення водія",
    documentTypeResidencePermit: "Посвідка на проживання",

    registrationDocumentNumber: "Серія та номер",
    registrationDocumentIssueOrganization: "Орган, що видав",
    registrationDocumentIssueDate: "Дата видачі",

    ownerIsInsured: "Я – власник транспортного засобу",
    ownerIsNotInsured: "Я не є власником транспортного засобу",

    colorBlack: "Чорний",
    colorDarkBlue: "Синій",
    colorGreen: "Зелений",
    colorBeige: "Бежевий",
    colorRed: "Червоний",
    colorViolet: "Фіолетовий",
    colorBrown: "Коричневий",
    colorGray: "Сірий",
    colorOrange: "Оранжевий",
    colorYellow: "Жовтий",
    colorWhite: "Білий",

    tarifficationDescriptionHeader: "Автоцивілка від ARX - це",
    tarifficationDescriptionElement1: "Повне покриття ваших витрат при настанні ДТП з іншим учасником",
    tarifficationDescriptionElement2: "З програмою Автоцивілка «Все включено» вам не потрібно звертатися за виплатою в іншу страхову компанію (пряме врегулювання в 100% випадків), у разі вини іншого учасника ДТП",
    tarifficationDescriptionElement3: "AUDASMART - можливість отримати страхову виплату в максимально короткий термін без візиту в офіс страхової чи на СТО",
    tarifficationDescriptionHeaderSmartDrive: "Автоцивілка СМАРТ - це",
    tarifficationDescriptionElement1SmartDrive: "10% знижки гарантовано за умови встановлення додатку Smart Drive",
    tarifficationDescriptionElement2SmartDrive: "до 25% знижки за умови укладення договору на наступний рік",
    tarifficationDescriptionElement3SmartDrive: "1 000 000 грн додаткового покриття у разі купівлі добровільної автоцивілки",
    tarifficationDescriptionHeaderGreenCard: "Зелена картка від ARX – це",
    tarifficationDescriptionGreenCardElement1: "міжнародна автоцивілка, яка покриває вашу відповідальність за шкоду, що може бути нанесена майну, здоров’ю та життю постраждалих осіб на території країн-членів системи «Зелена картка».",
    tarifficationDescriptionGreenCardElement2: "З послугою \"Автоконсьєрж\" ви зможете отримати цілодобову інформаційну підтримку у разі ДТП, а також організацію технічної допомоги. Послуги надаються українською мовою.",
    tarifficationTitle: "Дані для розрахунку:",

    contractStart: "Початок договору",
    contractStartDate: "Дата початку дії договору",
    contractEndDate: "Дата закінчення дії договору",
    contractDuration: "Строк дії договору",
    contractMtplMtsbu: "Договір Автоцивілка на сайті МТСБУ",
    contractGreenCardMtsbu: "Договір Зелена картка на сайті МТСБУ",

    quotationDownload: "Завантажити поліс",
    quotationChoose: "Обрати",

    agreementCheckbox1: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (надалі - Страховик) договір обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів, договір добровільного страхування цивільної відповідальності власників наземних транспортних засобів та договір добровільного страхування наземного транспорту (приєднання) (надалі - Договори) щодо зазначеного транспортного засобу. ",
    agreementCheckbox2: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (надалі - Страховик) договір обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів та договір добровільного страхування наземного транспорту (приєднання) (надалі - Договори) щодо зазначеного транспортного засобу. ",
    agreementCheckbox3: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (надалі - Страховик) договір обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів та договір добровільного страхування цивільної відповідальності власників наземних транспортних засобів (надалі - Договори) щодо зазначеного транспортного засобу. ",
    agreementCheckbox4: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (надалі - Страховик) договір обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів (надалі - Договір) щодо зазначеного транспортного засобу. ",
    agreementCheckbox1in2025: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (далі - Страховик) договір обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів, договір страхування цивільної відповідальності власників наземних транспортних засобів та договір страхування наземного транспорту (далі - Договори) щодо зазначеного транспортного засобу.",
    agreementCheckbox2in2025: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (далі - Страховик) договір обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів та договір страхування наземного транспорту (приєднання) (далі - Договори) щодо зазначеного транспортного засобу. ",
    agreementCheckbox3in2025: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (далі - Страховик) договір обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів та договір страхування цивільної відповідальності власників наземних транспортних засобів (далі - Договори) щодо зазначеного транспортного засобу. ",
    agreementCheckbox4in2025: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (далі - Страховик) договір обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів (далі - Договір) щодо зазначеного транспортного засобу. ",
    agreementLabel1: "Всі надані мною Страховику дані є точними та достовірними. Даю згоду на обробку та використання моїх персональних даних (далі - ПД), в тому числі на передачу ПД третім особам або іноземним суб‘єктам, з метою оформлення та укладення Договорів, виконання вимог законодавства та реалізації прав, наданих законодавством Страховику, забезпечення відносин в сфері бухобліку, реклами, оцінки якості сервісу. Дійсним також підтверджую, що повідомлений/а про мої права, як суб‘єкта ПД, визначені законом, мету збору даних та осіб, яким передаються мої ПД. Додатково повідомлений/а, що при несплаті страхового платежу, договір страхування не набирає чинності та страхове покриття відсутнє.",
    agreementLabel2: "Всі надані мною Страховику дані є точними та достовірними. Даю згоду на обробку та використання моїх персональних даних (далі - ПД), в тому числі на передачу ПД третім особам або іноземним суб‘єктам, з метою оформлення та укладення Договору, виконання вимог законодавства та реалізації прав, наданих законодавством Страховику, забезпечення відносин в сфері бухобліку, реклами, оцінки якості сервісу. Дійсним також підтверджую, що повідомлений/а про мої права, як суб‘єкта ПД, визначені законом, мету збору даних та осіб, яким передаються мої ПД. Додатково повідомлений/а, що при несплаті страхового платежу, договір страхування не набирає чинності та страхове покриття відсутнє.",
    agreement1: "Надаю згоду на використання в усіх без виключення договірних відносинах зі Страхувальником та при здійсненні переписки з ним, в тому числі ділової, при посвідченні документів від імені Страховика особистого підпису уповноваженої на такі дії особи або факсимільного відтворення за допомогою засобів електронного або іншого копіювання аналога її власноручного підпису, наведеного нижче:",
    agreement2: "П.І.Б. та посада уповноваженої особи Страховика",
    agreement3: "Зразок підпису уповноваженої особи Страховика",
    agreement4: "Голова Правління Перетяжко А.І.",
    greenAgreementCheckbox: "Підтверджую, що: бажаю укласти з АТ «СК «АРКС» (надалі - Страховик) договір міжнародного обов‘язкового страхування цивільно-правової відповідальності власників наземних транспортних засобів (надалі - Договір) щодо зазначеного транспортного засобу.",
    greenPeronalDataAgreement: "Всі надані мною Страховику дані є точними та достовірними. Даю згоду на обробку та використання моїх персональних даних (далі - ПД), в тому числі на передачу ПД третім особам або іноземним суб‘єктам, з метою оформлення та укладення Договору, виконання вимог законодавства та реалізації прав, наданих законодавством Страховику, забезпечення відносин в сфері бухобліку, реклами, оцінки якості сервісу. Дійсним також підтверджую, що повідомлений/а про мої права, як суб‘єкта ПД, визначені законом, мету збору даних та осіб, яким передаються мої ПД. Додатково повідомлений/а, що при несплаті страхового платежу, договір страхування не набирає чинності та страхове покриття відсутнє.",
    greenFaxSignAgreement: "Надаю згоду на використання в усіх без виключення договірних відносинах зі Страхувальником та при здійсненні переписки з ним, в тому числі ділової, при посвідченні документів від імені Страховика особистого підпису уповноваженої на такі дії особи або факсимільного відтворення за допомогою засобів електронного або іншого копіювання аналога її власноручного підпису, наведеного нижче:",

    agreementUserInformedPart1: "Підтверджую, що перед укладенням договору страхування мене було забезпечено доступною та вичерпною інформацією про страховий продукт",
    agreementUserInformedPart2: ", страховика",
    agreementUserInformedPart3: "та іншою передбаченою законодавством інформацією у спосіб, який встановлений законодавством, зокрема, але не виключно, за домовленістю зі мною з урахуванням специфіки страхового продукту та потреб клієнта. Цієї інформації мені достатньо для прийняття усвідомленого рішення про укладення договору страхування.",

    partyPerson: "Фізична особа",
    partyOrganization: "Юридична особа",

    personalInfoData: "Дані Страхувальника",
    personalInfoSurname: "Прізвище",
    personalInfoName: "Ім'я",
    personalInfoMiddleName: "По батькові",
    personalInfoBirthDate: "Дата народження",
    personalInfoLivingAddress: "Адреса проживання (місто, вулиця, будинок)",
    personalInfoLivingPhone: "Телефон",
    personalInfoResident: "Я є резидентом України",
    personalInfoResidentTooltip: "Якщо ви маєте паспорт громадянина України, то залишіть відмітку в полі «Я є резидентом України», якщо у вас немає паспорта громадянина України – видаліть відмітку в полі «Я є резидентом України»",
    personalInfoResidentCountry: "Країна громадянства",
    personalInfoIpn: "ІПН",
    personalInfoRegistrationDocument: "Документ, що посвідчує особу",

    insured: "Страхувальник",
    insuredFullName: "ПІБ:",
    insuredFullNameLong: "Прізвище та ім'я:",
    insuredIpn: "ІПН:",
    insuredBirthDate: "Дата народження:",
    insuredPhone: "Телефон",
    insuredEmail: "Email:",
    insuredEmail2: "Email",
    insuredRegisterCity: "Місто реєстрації:",

    phoneWithDots: "Телефон:",

    interesting: "Вас може зацікавити:",
    antivirus: "Антивірус від ARX",
    casco: "КАСКО",
    family: "Родинне коло",
    wait: "Зачекати",
    pay: "Сплатити",
    yourOrder: "Ваше замовлення",
    firstPayment: "1 платіж",
    popular: "Найбільш популярний",
    installmentAlternative: "або сплачуйте частинами",

    franchise: "Франшиза:",
    franchise2: "Франшиза",
    franchise3: "франшиза - ",
    noFranchise: "без франшизи",
    franchiseDescription: " – це сума збитку, яка не відшкодовується страховою компанією, а сплачується самостійно у разі ДТП. ",
    chooseProgram: "Оберіть програму страхування:",
    chooseOption: "Оберіть з вибраних опцій",
    packageMtplName: "Проста \"Автоцивілка\"",
    packageOptionMtplName: "Базове покриття «Автоцивілка»",
    packageOptionMtplText1: "Страхова сума за збитки, нанесені життю та здоров’ю потерпілих – 320 000 гривень на одного потерпілого.",
    packageOptionMtplText2: "Страхова сума за збитки, нанесені майну потерпілих – 160 000 гривень на одного потерпілого.",
    packageOptionMtplText1in2025: "Страхова сума за збитки, нанесені життю та здоров’ю потерпілих – 500 000 гривень на одного потерпілого.",
    packageOptionMtplText2in2025: "Страхова сума за збитки, нанесені майну потерпілих – 250 000 гривень на одного потерпілого.",
    packageOptionVtplName: "Додаткова автоцивілка",
    packageCascoName: "Автоцивілка \"Все включено\"",
    packageOptionCascoName: "КАСКО \"Прямий захист\"",
    packageOptionCascoNameSmartDrive: "КАСКО \"Прямий захист\"",
    packageVtplName: "Розширити захист",
    packageVtplDescription: "Якщо збиток перевищить страхову суму за Обов'язковою автоцивілкою, різницю відшкодуємо за Додатковою автоцивілкою.",
    packageOptionEmptyText: "З урахуванням зазначених на попередньому кроці даних, за договором не може бути застосовано обрану франшизу.",

    partyTypePerson: "Фізична особа",

    Kyiv: "Київ ",
    Ukraine: 'Україна',
    KyivFull: "Київ (Київ р-н, Київ обл.)",
    Odesa: "Одеса ",
    OdesaFull: "Одеса (Одеська р-н, Одеська обл.)",
    Lviv: "Львів ",
    LvivFull: "Львів (Львівська р-н, Львівська обл.)",
    Kharkiv: "Харків ",
    KharkivFull: "Харків (Харківська р-н, Харківська обл.)",
    Dnipro: "Дніпро ",
    DniproFull: "Дніпро (Дніпропетровська р-н, Дніпропетровська обл.)",
    Zaporizhzhia: "Запоріжжя ",
    ZaporizhzhiaFull: "Запоріжжя (Запорізька р-н, Запорізька обл.)",
    China: "КНДР ",
    Iran: "Іран ",

    durationMapDAYS_15: "15 днів",
    durationMapDAYS_21: "21 день",
    durationMapMONTH_1: "1 місяць",
    durationMapMONTHS_2: "2 місяці",
    durationMapMONTHS_3: "3 місяці",
    durationMapMONTHS_4: "4 місяці",
    durationMapMONTHS_5: "5 місяців",
    durationMapMONTHS_6: "6 місяців",
    durationMapMONTHS_7: "7 місяців",
    durationMapMONTHS_8: "8 місяців",
    durationMapMONTHS_9: "9 місяців",
    durationMapMONTHS_10: "10 місяців",
    durationMapMONTHS_11: "11 місяців",
    durationMapYEAR_1: "1 рік",

    preVerificationMessageReadMany: "Я прочитав та погоджуюсь з направленими мені",
    preVerificationMessageReadOne: "Я прочитав та погоджуюсь з направленим мені",
    preVerificationMessageSign: ", що підтверджую своїм підписом нижче:",
    preVerificationMessageCasco: "Договором страхування КАСКО \"Прямий захист\"",
    preVerificationMessageCascoSmartDrive: "Договором страхування КАСКО \"Прямий захист\"",
    preVerificationMessageVtpl: "Договором страхування \"Додаткова автоцивілка\"",
    preVerificationMessageTravel: "Договором страхування для подорожуючих закордон",

    stepsZero: "Вам залишилось нуль кроків до покупки",
    stepsOne: "Вам залишився один крок до покупки",
    stepsTwo: "Вам залишилось два кроки до покупки",
    stepsThree: "Вам залишилось три кроки до покупки",
    stepsFour: "Вам залишилось чотири кроки до покупки",
    stepsFive: "Вам залишилось п'ять кроків до покупки",
    stepsSix: "Вам залишилось шість кроків до покупки",
    stepsBack: "Назад",
    stepsNext: "Далі",

    dgoInfo1: "За статистикою, більше ніж в 40% випадків ДТП, завдані збитки перевищують 160 000 грн. Будь ",
    dgoInfo1in2025: "За значною кількістю випадків ДТП завдані збитки перевищують 250 000 грн. Будь ",
    dgoInfo2: "відповідальним водієм",
    dgoInfo3: " — потурбуйся про додаткове покриття.",
    dgoChoose: "Обрати додаткове покриття",
    dgoDontChoose: "Не хочу додаткового покриття",

    successfulQuotationMTPL: "Ви успішно оформили обов'язкову автоцивілку.",
    successfulQuotationMTPL_VTPL: "Ви успішно оформили обов'язкову і додаткову автоцивілку.",
    successfulQuotationMTPL_CASCO: "Ви успішно оформили обов'язкову автоцивілку і КАСКО «Прямий захист»",
    successfulQuotationMTPL_VTPL_CASCO: "Ви успішно оформили обов'язкову і додаткову автоцивілку, КАСКО «Прямий захист»",
    successfulQuotation1: "На e-mail: ",
    successfulQuotation2: " відправлено страховий поліс.",
    successfulQuotation1a: "Очікуйте viber-повідомлення на смартфон з реквізитами полісу.",
    successfulQuotation2a: " Також на ваш e-mail:",
    successfulQuotation2b: " відправлено укладений електронний поліс.",
    successfullQuotationTravel: "Ви успішно оформили поліс туристичного страхування!",
    successfullQuotationGreenCard: "Ви успішно оформили Зелену картку. ",

    fastCalculation: "Швидкий розрахунок",

    successfulQuotation: {
        promo: {
            casco: {
                title: "КАСКО",
                description: "Це вибір відповідальних людей. Обирайте опцію, яка підходить саме вам: від найдоступнішої до повного КАСКО"
            },
            antivirus: {
                title: "Антивірус від ARX",
                description: "Страхування на випадок госпіталізації з пневмонією будь-якого характеру (бактеріальна, атипова, вірусна, в тому числі викликана COVID-19) чи передчасного відходу з життя."
            },
            family: {
                title: "Родинне коло",
                description: "Програма страхування життя та від нещасних випадків для всієї родини від ARX Life"
            }
        }
    },

    unsuccessfulPayment1: "Ми обробляємо ваш платіж. Договір страхування надійде на вашу електронну пошту протягом 15 хвилин.",
    unsuccessfulPayment2: "Якщо процес оплати не завершився — спробуйте ще раз.",
    unsuccessfulPayment3: "Якщо кошти з картки списано, а лист з договором не надійшов протягом 15 хв — зателефонуйте нам на гарячу лінію, і ми допоможемо.",
    unsuccessfulPayment4: "Очікування може зайняти до 10 хв.",

    currencyUAH: "грн",

    smartDrive: {
        learnMoreAboutSmartDrive: "Дізнатися більше про умови",
        packageBaseName: "Smart",
        packageOptionCascoName: "КАСКО «Прямий Захист»",
        packageBasePlusName: "Smart +",
        vtplSumInsuredSelect: "Оберіть ліміт за додатковою автоцивілкою:",
        askPhone: {
            error: "За вказаним номером телефону не вдалося отримати підтвердження про вашу реєстрацію в мобільному застосунку «Smart Drive»",
            errorEmpty: "Будь ласка вкажіть номер телефону",
        }
    },
    secondPaymentInfo: '<span>2-й платіж</span> сплачується через 4 місяці та буде залежати від вашого рейтингу\n' +
        '                                (кількості отриманих балів) в мобільному додатку Smart Drive та пробігу авто.\n' +
        '                                Завантажуйте додаток Smart Drive після оформлення полісу та отримуйте знижку.',
    datePlaceholder: "дд.мм.рррр",
    indexHTML: {
        content: "Придбайте перший електронний поліс автоцивілки в Україні. З онлайн автоцивілкою «ARX» ви не будете більше чекати в черзі.",
        title: "Електронна Автоцивілка – покупка | СК «ARX»"
    },

    errorMessageDialog: {
        btnGood: "Добре",
        btnDetails: "Докладно"
    },
    questionsPopup: {
        title: "Питання, що часто виникають",
        text1: "Як відбувається врегулювання за електронним полісом ОСЦПВ?",
        text2: "Врегулювання відбувається дистанційно, тож вам не доведеться приїжджати в офіс ARX.",
        text3: "Укладений поліс необхідно роздрукувати та возити в автомобілі?",
        text4: "Це робити необов’язково. Водій повинен\n" +
            "мати при собі поліс автоцивілки на паперовому або електронному носії. " +
            "Поліс можна роздрукувати, або просто показати його співробітнику поліції " +
            "на екрані смартфона або іншого девайсу.",
        text5: "Чи буде діяти страховка, якщо за кермом не власник автомобіля?",
        text6: "Так, буде. Адже страхується відповідальність особи, яка керує вказаним в договорі авто.",
        text7: "Де можна перевірити чинність електронної автоцивілки?",
        text8: "Перевірити чинність електронної автоцивілки можна на сайті",
        text9: "МТСБУ",
        text10: "Як змінити строк дії електронної автоцивілки?",
        text11: "В такому випадку вам необхідно звернутися до нашого найближчого офісу ARX.",
        text12: "Чи можна оформити ОСЦПВ онлайн для авто, які підлягають обов’язковому проходженню технічного контролю (ОТК)?",
        text13: "Так, для цього вам потрібно вказати дату наступного техогляду.",
        text14: "Що таке страхова сума та франшиза?",
        text15: "Страхова сума",
        text16: " - це грошова сума, у межах якої страховик зобов’язаний виплатити страхове відшкодування.",
        text17: "Франшиза",
        text18: " - це сума, яка не відшкодовується страховою компанією." +
            " Наприклад, якщо за умовами договору франшиза становить 2 000 грн, а в результаті" +
            " ДТП іншому авто буде завдано збитків на 50 000 грн, то страхова компанія виплатить" +
            " відшкодування за вирахуванням франшизи, тобто 48 000 грн.",
        text19: "Випадково придбали електронну автоцивілку двічі — що робити?",
        text20: "У цьому випадку вам необхідно звернутися до найближчого офісу ARX.",
        text21: "Електронна автоцивілка діє так само, як і звичайна автоцивілка, роздрукована на бланку?",
        text22: "Так, це та ж сама автоцивілка, тільки у вашому смартфоні.",
        text23: "Скільки коштує оформити електронний поліс ОСАГО?",
        text24: "Це розраховується індивідуально для кожного авто. " +
            "Щоб дізнатися вартість поліса, заповніть всього 6 полів: " +
            "тип, марка транспортного засобу, місце реєстрації власника транспортного засобу, " +
            "рік випуску транспортного засобу, категорія власника транспортного засобу " +
            "(фізична або юридична особа), рік народження власника транспортного засобу.",
        text25: "Від чого залежить вартість поліса?",
        text26: "Вартість залежить від:",
        text27: "типу транспортного засобу;",
        text28: "місця реєстрації власника авто;",
        text29: "категорії власника авто (фізична або юридична особа);",
        text30: "сфери використання авто;",
        text31: "віку власника авто;",
        text32: "сроку експлуатації авто;",
        text33: "розміру франшизи;",
        text34: "строку дії поліса.",
        text35: "Для оформлення поліса з використанням знижки для пільгової категорії громадян необхідно звернутися до офісу ARX",
        text36: "Які документи потрібні, щоб оформити автоцивілку?",
        text37: "Вам необхідно: український паспорт або посвідчення водія," +
            " ідентифікаційний номер, технічний паспорт, протокол перевірки" +
            " технічного стану авто, якщо транспортний засіб підлягає " +
            " обов’язковому технічному огляду.",
        text38: "Що таке страховий випадок?",
        text39: "ДТП, яка сталася за участю забезпеченого" +
            " транспортного засобу, внаслідок якої настає цивільна відповідальність" +
            " страхувальника за заподіяну цим транспортним засобом шкоду життю, " +
            " здоров'ю та / або майну третіх осіб.",
        text40: "Який вигляд має цей поліс?",
        text41: "Після оплати страхового платежу електронний договір",
        text42: "«Зелена картка»",
        text43: "(чорно-білий страховий сертифікат, що підтверджує укладення договору «Зелена картка» та візуальна форма поліса)буде відправлений на вказаний e-mail при оформленні. Отриманий страховий сертифікат необхідно видрукувати та мати його паперовий примірник в застрахованому авто для пред’явлення уповноваженим іноземним контролюючим органам.",
        text44: "Для чого потрібна і чи є обов'язковою «Зелена картка»?",
        text45: "Міжнародний сертифікат «Зелена картка» — обов'язковий документ для поїздок за кордон на власному авто; це свого роду автоцивілка, але для виїзду за межі країни. Перевірка наявності поліса здійснюється під час перетину кордону України - на митному контролі або поліцейськими в країні перебування.",
        text46: 'Які збитки покриває "Зелена картка"?',
        text47: "«Зелена картка» покриває цивільну відповідальність страхувальника внаслідок ДТП, яка сталась за кордоном, за участю забезпеченого транспортного засобу та відшкодовує матеріальні збитки, які завдані майну, життю або здоров'ю потерпілих третіх осіб.",
        text48: "Яка страхова сума за договором?",
        text49: "Розміри лімітів відповідальності (страхова сума) встановлюються відповідно до законодавства тієї країни, на території якої сталася ДТП та надаються в розділі «Документи».",
        text50: "Чи потрібно укладати поліси на кожного водія, який буде керувати авто?",
        text51: "Ні, не потрібно. В полісі вказується один водій, але за кермом може перебувати будь-яка особа, яка на законних підставах керує забезпеченим транспортним засобом. Водночас рекомендується вказувати дані водія, який керуватиме забезпеченим ТЗ в країні перебування.",
        text52: "Як перевірити, чи дійсна страховка?",
        text53: "Пройшовши смс-ідентифікацію та сплативши страховий платіж, за QR-кодом з отриманого страхового сертифіката або QR-кодом/прямим посиланням із поліса можна перевірити дійсність та реєстрацію договору «Зелена картка» в централізованій базі МТСБУ.",
        text54: "Що робити у разі страхового випадку?",
        text55: "При настанні ДТП території країни відвідування необхідно",
        text56: "зафіксувати місце ДТП за допомогою фото- або відеозйомки;",
        text57: "викликати поліцію або скласти з другим учасником ДТП Європротокол;",
        text58: "отримати довідку поліції про обставини ДТП;",
        text59: "при наявності вини страхувальника, зазначеного в картці міжнародного автомобільного страхування, передати іншому учаснику ДТП (потерпілому) фотокопію або копію цієї картки;",
        text60: 'повідомити протягом 15 (п’ятнадцяти) днів свою страхову компанію про настання ДТП будь-яким способом зв’язку, зазначеному в картці.У разі відсутності у іноземного водія-винуватця страхового покриття на дату ДТП, або ж якщо ДТП сталося за участю водіїв з різних країн на території третьої країни, слід звернутися безпосередньо до національного Бюро країни ДТП.',
        text61: "Чи можна придбати поліс «Зелена картка» за кордоном?",
        text62: "Договір «Зелена картка» вигідніше придбати в Україні до перетину кордону. Покупка полісу на кордоні або автоцивілки в іншій країні буде дорожчою через комісію страховому агенту, значно вищі ціни на страхові послуги в Європі та необхідність покупки полісів ОСПЦВ кожної країни, якщо ви буде перетинати кордон кількох країн.",
        text63: "Від чого залежить ціна на поліс «Зелена картка»?",
        text64: "Розміри єдиних страхових платежів за полісами «Зелена картка» встановлюються МТСБУ. Вартість полісу залежать від типу транспортного засобу, строку перебування за кордоном (15 днів, від 1 місяця до 1 року) та території дії, на яку поширюється договір.",
        text65: "Що таке Європротокол та як його заповнити?",
        text66: 'Європротокол - повідомлення про ДТП, яке складається без участі уповноважених співробітників поліції країни перебування, за участю тільки забезпечених транспортних засобів. З версіями бланків Європротоколу та інструкціями із заповнення залежно від країни перебування можна ознайомитись в блоці "Документи — Європротокол".',
        text67: "Чи є знижка для пенсіонерів та пільговиків?",
        text68: "Пільги, що передбачаються чинним законодавством про ОСЦПВ, на договори міжнародного страхування «Зелена картка» не поширюються.",
        text69: "Для перетину декількох кордонів потрібно купувати поліс для кожної країни окремо?",
        text70: "Якщо ви плануєте відвідати кілька країн, немає потреби укладати поліс для кожної. Вам підійде поліс, дія якого поширюється в усіх 43 країнах-учасницях системи «Зелена картка». ",
        text71: "Чи можна оформити договір «Зелена картка» на авто з іноземними державними номерами?",
        text72: "Така можливість відсутня. «Зелена картка» оформляється тільки на транспортні засоби, які зареєстровані в Україні."
    },
    questionsPopupTravel: {
        title: "Запитання та відповіді Туристичне страхування",
        text1: "Чи покриває туристичне страхування СOVID-19?",
        text2: "Всі пакети туристичсного страхування від ARX покривають надання невідкладної медичної допомоги у зв’язку зі захворюваннями, що пов’язані з особливо небезпечними інфекціями (в тому числі COVID-19).",
        text3: "Чи покриває страховий поліс затримку рейсу / затримку багажу.",
        text4: "Затримку рейса / багажу покриває тільки розширений страховий поліс. За кожну повну годину затримки рейсу / багажу понад 4 години компенсується € 10, але не більше € 100 за одну поїздку.",
        text5: "Чи обов'язкова наявність мед страховки для виїзду за кордон?",
        text6: "Для відвідування деяких країн обов'язково оформляти страховку — часто її просять пред'явити при в'їзді в країну, а в деяких випадках вона необхідна вже на етапі оформлення візи.",
        text7: "Яка вартість страховки для виїзду за кордон?",
        text8: "Стандартний поліс з покриттям € 30 000 обійдеться близько € 2,5 в день (для всіх країн, окрім США і Канади) або від € 10 (для всіх країн світу). З покриттям € 50 000 - від € 3,5 або € 15 відповідно.",
        text9: "Що таке страховий ліміт?",
        text10: "Це максимальна сума, яка може бути компенсована в рамках одного страхового випадку, найчастіше - 30000 або 50000 євро або доларів. В рамках цієї суми, як правило, оплачується лікування до зняття гострого стану, використовувати її цілком можливо лише у важких випадках (складна операція або транспортування пацієнта в його країну за медичними показаннями, наприклад).",

        text11: "Що покриває базовий туристичний страховий поліс?",
        text12: "Невідкладну медичну допомогу (амбулаторну або стаціонарну).",
        text13: "Транспортування до найближчого медичного закладу.",
        text14: "Придбання ліків, призначених лікарем.",
        text15: "Невідкладну стоматологічну допомогу в рамках ліміту.",
        text16: "Оплату витрат на зв'язок (мається на увазі передача термінових повідомлень, пов'язаних зі страховим випадком).",
        text17: "Медичну евакуацію - доставку застрахованого до медичного закладу в рідній країні, якщо це доцільно.",
        text18: "Репатріацію тіла в разі смерті застрахованого.",

        text19: "Що не покриває страховка для виїзду за кордон?",
        text20: "лікування травм, отриманих у форс-мажорних обставинах: у ході військових конфліктів, громадських заворушень, революцій або терактів, а також під час перебування в країнах, відвідування яких не рекомендовано МВС України.",
        text21: "лікування захворювань, що виникли до укладення договору",
        text22: "лікування захворювань і травм, які стали наслідком дій з невиправданим ризиком для життя і здоров'я, виконання фізичної роботи за наймом (якщо страховий поліс оформлений не з цією метою), заняття професійним спортом або участі в змаганнях",
        text23: "медичні товари та медикаменти для оздоровлення та профілактики: вакцини, вітаміни, профілактичний огляд, санаторно-курортне лікування тощо",
        text24: "лікування травм, які застрахований отримав під дією алкоголю або наркотиків",
        text25: "косметичні та пластичні операції",
        text26: "стоматологічні послуги (крім екстреного лікування)",
        text27: "пологи",

        text28: "Який поліс краще придбати електронний або паперовий? Електронний поліс обов'язково видруковувати?",
        text29: "Обидва поліси підходять для проходження кордону. При цьому досить зберегти на свій смартфон PDF файл страхового поліса. При необхідності пред'явити його на кордоні.",
        text30: "Чи можна оформити туристичну страховку, перебуваючи вже в іншій країні?",
        text31: "На жаль, так зробити неможливо. Головна умова для активації туристичного поліса — це перетин кордону України, чи то страховка для поїздки в Європу, страховка шенген, або страховка для поїздки в іншу яку-небудь країну.",
        text32: "Купили туристичну страховку на сайті, але помилилися з датами. Як можна поміняти дати?",
        text33: "Для цього необхідно звернутися у відділення нашої компанії та написати заяву про розірвання страхового поліса й оформити новий поліс. Якщо ви звернетеся до початку дати дії поліса, вам повернеться сума за оплату в 100% розмірі.",
        text34: "Не виходить оплатити картою на сайті. Що робити?",
        text35: "Перевірити який ліміт на оплату онлайн-покупок встановлений по вашій картці. Для цього зателефонуйте у свій банк",
        text36: "Що потрібно для оформлення поліса страховки для візи?",
        text37: "Для отримання потрібного поліса уточніть на сайті посольства країни вимоги до медстраховки для візи.",
        text38: "Як придбати страховку онлайн для дитини?",
        text39: "Вкажіть серію та номер закордонного паспорта батька, в чий паспорт вписана дитина, а також дані дитини. Діти до 1 року на страхування не приймаються.",
        text40: "Що робити якщо стався страховий випадок?",
        text41: "Звернутися до асистуючої компанії. Контакти вказані в полісі страхування, тому поліс необхідно тримати при собі. При спілкуванні з оператором необхідно вказати свої ПІБ, номер контактного телефону, адресу місця знаходження, назву страхової компанії, № договору страхування, термін його дії, описати проблему і характер необхідної допомоги. Асистуюча компанія реєструє страхова подія і організовує надання медичної допомоги в тих мед. установах, які перебувають в місці перебування Клієнта. Після надання медичної допомоги Застрахованій, асистуюча компанія сама оплачує послуги мед. Установи.",
        text42: "Що таке асистуюча компанія?",
        text43: "Це юридична особа, яка займається організацією та наданням послуг, розраховується з медичними установами та іншими установами за надану (згідно з договором страхування) допомогу.",
        text44: "Які документи потрібні для отримання відшкодування по страховому випадку?",
        text45: "Під час консультації або огляду лікаря обов'язково надайте йому оригінал страхового поліса. У свою чергу, від лікаря потрібно отримати копію медичного висновку і рецепти на медикаменти. Якщо раптом у вашій ситуації довелося частково оплатити медикаменти або лікування самостійно, то обов'язково збережете всі чеки і документи. Ми компенсуємо ці витрати після вашого повернення в Україну.",
        text46: "Чи існує туристична страховка для вагітних?",
        text47: "Програми страхування «Оптимальна» і «Преміальна» включають невідкладну гінекологічну допомогу до 7 місяцю вагітності.",
        text48: "Коли потрібно заявляти про страховий випадок?",
        text49: "В термін до 5 діб у разі неможливості своєчасного звернення.",
        text50: "Хочу змінити опцію туристичного поліса, як я можу це зробити?",
        text51: "В такому випадку ви можете розірвати договір і оформити новий з потрібною вам опцією (за умови, що ви ще перебуваєте в Україні). Вам доступний страховий медичний поліс для виїжджаючих за кордон вартістю від 13 до 16 грн в день в залежності від обраних опцій.",
        text52: "Як розірвати договір туристичного страхування?",
        text53: "Для розірвання потрібно написати заяву (зразок) на e-mail: info@arx.com.ua і направити скан копії: паспорта та ІПН. Якщо ви звертаєтеся для розірвання договору страхування до початку періоду страхування, кошти повертаються в 100% розмірі. А якщо договір вже вступив в свою силу, то кошти повертатися за невикористаний період і мінус 30% за ведення справи.",

        text54: "Що включає опція «активний відпочинок»?",
        text55: "У нашому випадку “активний відпочинок” — це захоплення на аматорському рівні:",
        text56: "зимовими видами спорту;",
        text57: "дайвінгом (глибина занурення до 18 метрів);",
        text58: "плаванням (в басейнах, річці, морі), аква-аеробікою;",
        text59: "рафтингом (1-2 рівень складності);",
        text60: "катанням на конях, верблюдах, слонах;",
        text61: "катанням на квадроциклах та багі (в тому числі перебування застрахованої особи в якості пасажира);",
        text62: "катанням на велосипеді;",
        text63: "парасейлингом (політ на парашуті (парасейлі) за катером);",
        text64: "трекінгом (1-2 категорії складності, за умови, що висота сходження не більше 2500 метрів);",
        text65: "пляжним футболом, волейболом;",
        text66: "сквошем;",
        text67: "бадмінтоном.",
        text68: "Професійне зайняття цими видами спорту та участь у змаганнях не покриваються страховкою.",

        text69: "Що включає опція «Спорт»?",
        text70: "У нашому випадку опція “спорт” — це захоплення на аматорському рівні:",
        text71: "рафтингом (3 і вище рівня складності)",
        text72: "автоспортом, мотоспортом",
        text73: "кінним спортом",
        text74: "банджо-джампінгом, роуп-джампінгом",
        text75: "серфінгом, кайтсерфінгом, вітрильним спортом, водними лижами, яхтингом, стрибками у воду",
        text76: "парашутним спортом, дельтапланеризмом, парапланеризмом, параглайдінгом",
        text77: "акробатикою, фрістайл-акробатикою, стрибками на батуті",
        text78: "скелелазанням на відкритій місцевості",
        text79: "дайвінгом (глибина занурення від 18 до 40 метрів)",
        text80: "Професійне зайняття цими видами спорту та участь у змаганнях не покриваються страховкою.",

        text81: "Можливо купити страховку за кордон, не будучи резидентом України?",
        text82: "Так, можливо."
    },
    noSmartDriveDialog: {
        title: " 10% знижка",
        message: " Отримуйте знижку 10% відразу під час купівлі полісу, завантаживши додаток Smart Drive",
        describtion: "до 25% знижки під час укладення договору на наступний рік",
        btnInstalled: "ВЖЕ ВСТАНОВИВ \"SMART DRIVE\"",
        btnWithout: "НЕ ХОЧУ ВСТАНОВЛЮВАТИ"
    },
    refs: {
        link: "https://arx.com.ua/",
        kontakty: "https://arx.com.ua/kontakty/",
        avtocivilka_all_inclusive: "https://arx.com.ua/produkty/avtotsyvilka/avtotsyvilka-vse-vklyucheno",
        avtocivilka: "https://arx.com.ua/produkty/avtotsyvilka/avtotsyvilka-online",
        emtpl: "https://arx.com.ua/store/emtpl",
        mtsbu: "http://www.mtsbu.ua/ua/",
        smart_drive_apple: "https://apps.apple.com/us/app/smart-drive/id1536021312",
        smart_drive_android: "https://play.google.com/store/apps/details?id=com.arx.smartdrive",
        myarx_apple: "https://apps.apple.com/ua/app/myarx/id1538353796",
        myarx_android: "https://play.google.com/store/apps/details?id=com.arx.myarx",
    },

    discount: {
        title: "Знижка для вправних водіїв на наступний рік!",
        text1: "Використовуючи додаток Smart Drive, можна отримати знижку на автоцивілку на наступний рік. Додаток Smart Drive оцінює стиль керування: чим більше балів в додатку, тим більша знижка: ",
        text2: "Загальна оцінка",
        text3: "до 59",
        text4: "60 – 69",
        text5: "70 – 79",
        text6: "80 – 89",
        text7: "від 90",
        text8: "Можлива знижка",
        text9: "0 %",
        text10: "10 %",
        text11: "15 %",
        text12: "20 %",
        text13: "25 %",
        text14: "Знижка на наступний рік надається, якщо:",
        text15: "вдалося отримати 60 і більше балів та проїхали протягом 60 днів з дати укладення договору понад 300 км;",
        text16: "за попереднім договором відсутні збитки;",
        text17: "новий договір укладається не пізніше ніж через 15 днів після закінчення дії попереднього договору;",
        text18: "не змінюється автомобіль та особа, котра оформлювала попередній договір страхування.",
        text19: "Знижка застосовується до суми оплати, яка розрахована відповідно до тарифікації ARX. Водночас ціна обов’язкової автоцивілки зі знижкою не може бути меншою ніж мінімальний платіж згідно з чинним законодавством.",
    },
    myARX: {
        text1: "MуARX - МОБІЛЬНИЙ ДОДАТОК ЗІ СТРАХУВАННЯ",
        text2: "Що пропонує додаток?",
        text3: "Інформацію про поточні договори медичного страхування, Автоцивілки, КАСКО, ДЦВ та туристичного страхування, що були придбані онлайн",
        text4: "Інформацію про договори, які припинили свою дію (у разі потреби написання заяви на отримання відшкодування).",
        text5: "Можна в будь-який час побачити: номер договору страхування, програму страхування, термін дії договору, контактний номер телефону для зв'язку зі страховою компанією",
        text6: "Договори страхування будуть показані в додатку, навіть якщо відсутнє інтернет-з'єднання на смартфоні." +
            " Щоб спілкуватися з нами, не треба переходити в месенджери — це можна зробити прямо в додатку.",
    },
    myARX2: {
        meta: "Вся необхідна інформація за договором страхування у вас у смартфоні ",
        title: "MуARX - мобільний додаток зі страхування. Що пропонує додаток?",
        items: ["Інформацію про поточні договори медичного страхування, Автоцивілки, КАСКО, ДЦВ, що були придбані онлайн. Інформацію про договори, які припинили свою дію (у разі потреби написання заяви на отримання відшкодування).",
            "Можна в будь-який час побачити: номер договору страхування, програму страхування, термін дії договору, контактний номер телефону для зв'язку зі страховою компанією.",
            "Договори страхування будуть показані в додатку, навіть якщо відсутнє інтернет-з'єднання на смартфоні. ",
            "У новому додатку до свого облікового запису можна додати договори страхування рідних і близьких, вказавши їх контактний номер телефону та дату народження. ",
            "Щоб спілкуватися з компанією, не треба переходити в месенджери — це можна зробити прямо в додатку."]
    },
    phoneContact: "0800 30 27 23",
    infoView: {
        text1: "Вже купував ",
        text2: "автоцивілку ",
        text3: "в ARX",
    },
    appAcceptedDlg: {
        text1: "Ваша заявка прийнята!",
        text2: "Ми зателефонуємо Вам найближчим часом",
        text3: "*У робочий час ",
        text4: "(Пн-Пт з 9:00 до 18:00, Сб з 10:00 до 15:00)",
        text5: " зателефонуємо вам протягом 5 хвилин, в іншому випадку - на наступний робочий день.",
    },
    buyMTPLDlg: {
        message: "Якщо не хочете встановлювати додаток “Smart Drive”, ви можете придбати " +
            "Автоцивілку “Все включено” або інший поліс, натиснувши кнопку “Продовжити”.",
        btnNext: "Продовжити",
        btnCancel: "Відмовитись",
        btnHaveNot: "У МЕНЕ НЕМАЄ \"SMART DRIVE\"",
    },
    contactPhoneDlg: "Якщо у вас залишились запитання, надішліть нам свій номер і ми обов'язково зв'яжемось з вами та відповімо на них.",
    mtplPhoneNumberConfirmDlg: {
        text1: "Підтвердження номеру",
        text2: "На ваш номер ",
        text3: " було надіслано СМС повідомлення з кодом доступу для підтвердження особи.",
        text4: "Повторіть, будь ласка, запит на отримання коду через 2 хвилини"
    },
    mtplPhoneNumberDlg: {
        text1: "Введіть дані власника автомобіля:",
        text2: "При введенні номеру телефону система заповнить дані про транспортний засіб та дані власника авто",
    },
    noDataByPhoneDlg: {
        text1: "На жаль, за даним номером ",
        text2: " не знайдено даних. Це може бути пов'язано з тим, що у вас нове авто або номеру не має в базі.",
        text3: "Спробуйте, будь ласка, підтягнути дані, ввівши державний номер авто",
    },
    mtlpReminderDialog: {
        title: "Нагадати про придбання страховки пізніше",
        subTitle: "Вкажіть місяць закінчення вашого поліса і E-mail, на який ми нагадаємо про покупку і запропонуємо найкращу ціну",
        emailPlaceholder: "Введіть e-mail",
        datePlaceholder: "Місяць закінчення",
        dateLabel: "Дата",
        subscribe: "Підписатися",
        validation: {
            format: "Невірний формат",
            required: "Поле обов'язкове для заповнення",
            pastDateError: "Дата не може бути в минулому",
        }
    },
    sdEnterNumberPhone: "Введіть номер телефону, який ви використовували під час реєстрації в мобільному додатку «Smart Drive».",
    salesPackageInfo: {
        text1: "Вартість страховки з урахуванням знижки ",
        text2: "10%",
        text3: " за умови встановлення додатку Smart Drive. Ціна без знижки ",
        text4: " грн",
    },
    understand: "Все зрозуміло",
    notChosen: "Не обрано",
    booleanTrue: "Так",
    booleanFalse: "Ні",
    loading: "Завантаження",
    greenCardScrnarioHeader: "Зелена картка",
    greenDataStep: {
        tooltipLatin: "Латиницею",
        cyrillic: "Кирилицею",
        tooltipLatinLikeForeignPassport: "Латиницею як у закордонному паспорті"
    },
    greenVerifyStep: {
        dataCheckHeader: "Зелена картка",
        coverageTerritory: "Територія дії полісу:",
        price: "Вартість:",
        validity: "Строк дії:",
        duration: "Строк страхування:"
    },
    greenTarifConfirmDialog: {
        title: "Cтраховий платіж:",
        changeParameters: "Змінити параметри"
    },
    greenFinalStep: {
        title: "Дякую!",
        message: "Ви успішно оформили Зелену картку. Очікуйте viber-повідомлення на смартфон з реквізитами полісу. Також на ваш e-mail: ",
        messageEnd: "відправлено укладений електронний поліс.",
        usefullInfo: {
            title: "Корисна інформація",
            memoLabel: "Пам'ятка міжнародної автоцивілки \"Зелена картка\"",
            limitsLabel: "Таблиця лімітів відповідальності для країн-членів ЗК"
        }
    },
    greenByNumberSearchDescription: "При введенні державного номера дані вже зареєстрованого автомобіля будуть автоматично заповнені.",
    greenCardDocumentNumber: "Номер закордонного паспорту",
    mimeTypeLabels: {
        pdf: "pdf"
    },
    feedback: {
        title: "Все сподобалось?",
        message: "Порекомендуйте сервіс своїм друзям, щоб вони також спробували!"
    },
    personalInfoDataSmartTooltipText: "Пропонуємо вказувати  дані особи, яка керуватиме авто в країні перебування",
    travelDialog: {
        text1: "Введіть дані",
        text2: "При введенні номера телефону, система підтягне дані про власника поліса туристичного страхування",
        text3: "Номер телефону, який ви використовували при попередній купівлі поліса",
        text4: "Який номер телефонa потрібно ввести",
        text5: "не знайдено даних",
        text6: "Спробуйте, будь ласка, ще раз або введіть дані вручну.",
        text7: "Спробувати інший номер"
    },
    newOptionsWereAdded: 'Додано нові опції',
    actions: {
        clear: "Очистити",
        close: "Закрити",
        open: "Відкрити"
    },
    travelNameLabel: "Ім'я латиницею",
    travelSurnameLabel: "Прізвище латиницею",
    travelAddressLabel: "Адреса проживання (місто, вулиця, будинок)",
    notRequiredPassport: "Не обов'язково",
    notRequiredPassportLabel: "Дане поле - необов'язкове. Якщо ви хочете, щоб номер паспорта був відображений у полісі, ви можете його вказати. Проте, згідно з законодавством України, поліс буде чинним і без цього.",
    validation: {
        required: 'Поле обов’язкове для заповнення',
        maxLength: 'Максимальна довжина поля {maxLength} символів',
    }
};
